import { render, staticRenderFns } from "./MobileObserver.vue?vue&type=template&id=2510f13e&scoped=true&"
import script from "./MobileObserver.vue?vue&type=script&lang=js&"
export * from "./MobileObserver.vue?vue&type=script&lang=js&"
import style0 from "./MobileObserver.vue?vue&type=style&index=0&id=2510f13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2510f13e",
  null
  
)

export default component.exports